module.exports = __webpack_public_path__ + "static/media/archiJs.d15311f2.png";